import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";

export default function RoleProtectedRoute({ children, requiredRole }) {
  const { token, role } = useAuth();

  if (!token) return <Navigate to="/" replace />;
  if (role !== requiredRole) return <Navigate to="/" replace />;

  return children;
}
